import axios from './index';

export const authLogin = async (emailOrMobile, password, rememberMe) => {
  const { data } = await axios.post('/auth/login', { emailOrMobile, password, rememberMe, isAdmin: true });
  return data.data;
};

export const fetchAuthMe = async () => {
  const { data } = await axios.get('/auth/me', {});
  return data.data;
};

export const createUserAccessLink = async (userId) => {
  const { data } = await axios.get(`/auth/access-link/${userId}/admin`);
  return data.data;
};
